interface IRotationUser {
  userid: string;
  active: number | string;
}

export const buildRotationChanges = (
  users: IRotationUser[],
  changes: Record<string, boolean>,
) => {
  const active: string[] = [];
  const inactive: string[] = [];

  users.forEach(user => {
    if (!(user.userid in changes)) return;
    const next = changes[user.userid];
    if (next === Boolean(Number(user.active))) return;
    (next ? active : inactive).push(user.userid);
  });

  return { active, inactive };
};
